<script lang="ts">
import type { FormatPriceOptions } from '#shared/utils/pricing'

export interface PriceProps extends FormatPriceOptions {
  size?: 'small' | 'medium' | 'large'
  bold?: boolean
  showSuffix?: boolean
}
</script>

<script setup lang="ts">
const props = withDefaults(
  defineProps<PriceProps>(),
  {
    taxIncluded: false,
    interval: undefined,
    size: 'small',
    bold: false,
    showSuffix: true,
  },
)

const formatted = computed(() => formatPrice(props))
</script>

<template>
  <strong
    v-if="size === 'small'"
    class="font-body text-md" :class="bold ? 'font-semibold' : 'font-normal'"
  >
    <span data-dd-privacy="mask" v-text="formatted.text" />
    <span v-if="showSuffix" v-text="formatted.suffix" />
  </strong>
  <div v-else class="flex flex-col items-center" :aria-label="formatted.label">
    <strong data-dd-privacy="mask" class="font-medium" aria-hidden="true" :class="{ 'title-l': size === 'large', 'title-s font-semibold': size === 'medium' }" v-text="formatted.text" />
    <span v-if="showSuffix" :class="{ 'title-s font-light': size === 'large', 'text-base': size === 'medium' }" aria-hidden="true" v-text="formatted.suffix" />
  </div>
</template>
